var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5682",
    "data-name": "Group 5682",
    transform: "translate(-0.344)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_559",
    "data-name": "Ellipse 559",
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    transform: "translate(0.344)",
    fill: "#dc4335"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5654",
    "data-name": "Group 5654",
    transform: "translate(8.021 13.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M286.184,198.088v4.64h7.674c-.305,1.993-2.325,5.843-7.674,5.843a8.546,8.546,0,0,1,0-17.09,7.6,7.6,0,0,1,5.394,2.091l3.671-3.536a12.96,12.96,0,0,0-9.074-3.536,13.535,13.535,0,1,0,0,27.071c7.486,0,13-5.493,13-13.23a12.359,12.359,0,0,0-.215-2.244H286.176Z",
    transform: "translate(-272.64 -186.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M318.726,198.969h-3.869V195.1h-3.869v3.869H307.12v3.869h3.868v3.869h3.869v-3.869h3.869Z",
    transform: "translate(-279.762 -187.381)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.24c4798b4bcee766570007be277445b2.svg";
export { ForwardRef as ReactComponent };